import React, {useState} from 'react'
import GeneratingSpinner from './GeneratingSpinner'
import { PencilIcon } from '@heroicons/react/solid';
import { EditableText } from '@blueprintjs/core';
import { SaveEditedContentInfirebase } from '../../Functions/EditText/EditText';
import EditHK from '../../Functions/Hotkeys/EditHK';
import { copyToClipboard } from '../../Functions/CopyToClipboard/CopyToClipboard';



function ContentGenerated({
    profile,
    contentGen,
    generating,
    editing,
    setEditing,
    setContentGen,
    fbProfile,
    auth,
    docId,
    vProp,
    intVal,
    shownButton,
    firstCopy 
}) {

    // console.log(contentGen)
    const [ editedContent, setEditedContent ] = useState(contentGen)

    const handleChange = (e) =>{
        setEditedContent(e)
    }

    const handleEditBtn = () =>{
        setEditedContent(contentGen)
        setEditing(true)
    }

    // console.log(contentGen)
    // console.log(editedContent)

    const handleSave = (e) => {
        setEditing(false)
        setContentGen(editedContent)
        SaveEditedContentInfirebase(fbProfile, auth, docId, editedContent)
    }

    // console.log(editedContent)

    return (
        <div className="">
            {generating ? 
            <div className='text-center'>
                <GeneratingSpinner />
            </div>
            :
            // Put something here, where if it is blank, tell them to click and interest and value prop to generate their message
            (contentGen === '' ?
            <div className=' border-4 border-dashed border-gray-200 rounded-lg h-max p-5 m-6 text-gray-600 text-base'>
                {/* Create a Personalized Message For {profile?.first_name}
                <br />
                <br />
                <li>Click the type of message you'd like in the top left</li>
                <li>Select the value prop you'd like to use next to their name</li>
                <li>Choose one of the interests that Bound found or enter in a custom one you found</li>
                <br />
                Click generate in the bottom right and you're good to go! */}
                <h1 className="text-xl text-center font-bold">Create A Message</h1>
                <br />
                <li>Above the prospects name, select the type of message you'd like generated.</li>
                <br />

                <li>In the profile card, select from the drop down the type of value proposition to use.</li>
                <br />
            
                <li>Select an interest Bound identified <b>OR</b> write your own custom interest.</li>
                <br />

                <span className="font-semibold">Click Create in the bottom right corner and your message will be created in seconds!</span>

            </div>
            :
            <div>
                {editing ? null :
                <div className='float-right'>
                    <button 
                    className="bg-gray-200 border-2 border-gray-500 rounded p-1 m-4 text-gray-600 focus:outline-none focus:bg-gray-600 focus:text-white hover:bg-gray-400"
                    onClick={handleEditBtn}
                    >
                    <span className='flex'><PencilIcon className="h-5 mr-1"/> Edit</span>
                    </button>
                    <EditHK 
                    handleEdit={handleEditBtn}
                    />
                </div>
                }
                {editing ?
                <div className="p-8 whitespace-pre-line">
                {/* This will be where Edit will be */}
                <EditableText 
                multiline={true}
                defaultValue={contentGen}
                onChange={handleChange}
                />
                <div className="mt-4 flex ">
                    <button
                    className='bg-blue-800 border-2 border-blue-600 hover:bg-blue-200 rounded p-1 font-semibold text-white hover:text-black'
                    onClick={handleSave}
                    >
                        Approve Changes
                    </button>
                    <button
                    className='bg-red-800 border-2 ml-4 border-red-600 hover:bg-red-200 rounded p-1 font-semibold text-white hover:text-black'
                    onClick={() => setEditing(false)}
                    >
                        Cancel
                    </button>
                </div>
                </div> 
                :
                // <button className="text-left p-0">
                    <div 
                        className="p-8 whitespace-pre-line text-base cursor-pointer"
                        onClick={() => 
                            copyToClipboard(
                            contentGen,
                            fbProfile,
                            docId,
                            vProp,
                            intVal,
                            shownButton,
                            firstCopy,
                            profile,
                            auth
                            )
                        }
                    >
                    {contentGen}
                    </div> 
                // </button>
                }
            </div>
            )
            }
        </div>
    )
}

export default ContentGenerated
